<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg3 class="login-box">
            <v-card class="pa-3" height="380px">
              <v-card-text>
                <v-form ref="isFormValid" class="pt-3" v-model="valid" lazy-validation>
                  <v-text-field append-icon="person" name="login" id="username" :label="$t('message.login.enterUserName')" disabled type="text" v-model="resetObj.username" :rules="$_requiredValidation"></v-text-field>
                  <v-text-field id="password" :append-icon="showPassword ? 'visibility' : 'visibility_off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" name="password" :label="$t('message.login.enterPassword')" :rules="$_requiredValidation" v-model="password"></v-text-field>
                  <v-text-field id="confirmpassword" :append-icon="showConfirm ? 'visibility' : 'visibility_off'" :type="showConfirm ? 'text' : 'password'" @click:append="showConfirm = !showConfirm" :rules="isPasswordNotMatch" name="password" :label="$t('message.login.enterConfirmPassword')" v-model="confirmpassword" @keyup.enter="updatePassword"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
              <v-spacer></v-spacer>
              <v-layout>
                  <v-flex lg6>
                    <v-btn block color="primary" id="updatebtn" @click="updatePassword" :loading="loading">{{$t('message.login.resetNow')}}</v-btn>
                  </v-flex>
              </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      showConfirm: false,
      showPassword: false,
      loading: false,
      valid: true,
      rememberMe: false,
      defaultLang: this.$i18n.locale,
      model: {
        email: '',
        language: this.$i18n.locale
      },
      password: '',
      resetObj: {},
      confirmpassword: ''
    }
  },
  computed: {
    isPasswordNotMatch () {
      return [val => val === this.password || this.$t('message.login.invalidPassword')]
    }
  },
  created () {
    this.$i18n.locale = 'no'
    this.$store.dispatch('logout')
    this.getUserDetails()
  },
  methods: {
    updatePassword () {
      if (this.$refs.isFormValid.validate()) {
        this.resetObj.token = this.$route.query.token
        this.resetObj.password = this.password
        this.$_executeApi('post', '/users/reset_password', this.resetObj)
          .then(res => {
            if (res) {
              this.resetObj = res.data
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.changedPassword') })
              this.$router.push('/login')
            }
          })
      }
    },
    getUserDetails () {
      if (this.$route.query.token) {
        var token = this.$route.query.token
        this.$_executeApi('get', `/users/get_by_otp?otp=${token}`)
          .then(res => {
            if (res) {
              this.resetObj = res.data
            }
          })
      }
    }
  }
}
</script>

<style scoped>
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
  .login-box {
    box-shadow: 0px 0px 34px #036693;
  }
</style>
